define('plugin/user-license/view/UserLicenseDetailsView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');

    /**
     * News details view
     *
     * @class NewsDetailsView
     */
    return LayoutView.extend({

        template: '#user_license_details_view',
        modelEvents: {
            'sync': 'render'
        },

        serializeData: function () {
            var config = Config.getInstance();
            return _.extend(LayoutView.prototype.serializeData.apply(this, arguments), {
                company: config.getOption('company_data')
            });
        }

    });

});
